<template>
    <div class="mx-auto text-center">
        <p class="title flex-grow-0 mb-0 font-weight-bold">{{ recipientInfo.name }}</p>
        <div class="d-flex justify-center">
            <div class="d-sm-flex d-block justify-center">
                <div class="d-flex">
                    <p
                      :class="$vuetify.breakpoint.mdAndUp ? 'title' : 'subtitle-1'"
                      class="flex-grow-0 mb-0 mr-1 font-weight-bold red--text"
                    >{{ recipientInfo.email }}</p>
                    <v-img
                        src="/images/success2.gif"
                        height="30"
                        max-width="30"
                    />
                </div>
                <v-btn @click="copyToClipboard(recipientInfo.email)">
                    Copy <v-icon>mdi-content-copy</v-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "match-confirmed-reveal-interac-payment",
        props: {
            recipientInfo: Object
        },
    }
</script>
